import Axios from 'axios';

import createAuthModule from './modules/auth';
import createFundsModule from './modules/funds';
import createIndexesModule from './modules/indexes';
import createHoldingsModule from './modules/holdings';
import createHouseFundsModule from './modules/housefunds';
import createProfileModule from './modules/profile';

export default (baseURL) => {
  const baseRequest = Axios.create({ baseURL });

  return {
    request: baseRequest,

    grantAuthorization(authToken) {
      baseRequest.defaults.headers.common.Authorization = `Bearer ${authToken}`;
    },

    revokeAuthorization() {
      delete baseRequest.defaults.headers.common.Authorization;
    },

    auth: createAuthModule(baseRequest),
    funds: createFundsModule(baseRequest),
    indexes: createIndexesModule(baseRequest),
    holdings: createHoldingsModule(baseRequest),
    houseFunds: createHouseFundsModule(baseRequest),
    profile: createProfileModule(baseRequest),
  };
};
